import { render, staticRenderFns } from "./ColetaPorKm.vue?vue&type=template&id=378de230&scoped=true&"
import script from "./ColetaPorKm.vue?vue&type=script&lang=js&"
export * from "./ColetaPorKm.vue?vue&type=script&lang=js&"
import style0 from "./ColetaPorKm.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ColetaPorKm.vue?vue&type=style&index=1&id=378de230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378de230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
